import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/kiss-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M168 152c23.8 0 52.7 29.3 55.8 71.4 0.3 3.8-2 7.2-5.6 8.3-3.1 1-7.2 0-9.3-3.7l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6-12.3 0-23.8 7.9-31.5 21.6l-9.5 17c-1.8 3.2-5.8 4.7-9.3 3.7-3.6-1.1-5.9-4.6-5.6-8.3 3.3-42.1 32.2-71.4 56-71.4zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM304 308c0 13-13.4 27.3-35.1 36.4 21.8 8.7 35.2 23 35.2 36 0 19.2-28.7 41.5-71.5 44h-0.5c-3.7 0-7-2.6-7.8-6.2-0.9-3.8 1.1-7.7 4.7-9.2l17-7.2c12.9-5.5 20.7-13.5 20.7-21.5s-7.8-16-20.8-21.5l-16.9-7.2c-6-2.6-5.7-12.4 0-14.8l17-7.2c12.9-5.5 20.7-13.5 20.7-21.5s-7.8-16-20.8-21.5l-16.9-7.2c-3.6-1.5-5.6-5.4-4.7-9.2 0.8-3.8 4.4-6.6 8.2-6.2 42.7 2.5 71.5 24.8 71.5 44zM328 152c23.8 0 52.7 29.3 55.8 71.4 0.3 3.8-2 7.2-5.6 8.3-3.1 1-7.2 0-9.3-3.7l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6-12.3 0-23.8 7.9-31.5 21.6l-9.5 17c-1.8 3.2-5.8 4.7-9.3 3.7-3.6-1.1-5.9-4.6-5.6-8.3 3.3-42.1 32.2-71.4 56-71.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/kiss-beam.js
// module id = 1784
// module chunks = 0